import { SITE_URL } from "@/lib/site"

/** Served by `app/whitepaper/download/route.ts` (Convex Storage, local RIVYU-WHITEPAPER-V1.4.pdf fallback). */
const DEFAULT_WHITEPAPER = "/whitepaper/download"

/** Public PDF URL — override with `NEXT_PUBLIC_WHITEPAPER_PDF_URL` in `.env.local`. May be relative or absolute. */
export const WHITEPAPER_PDF_URL = process.env.NEXT_PUBLIC_WHITEPAPER_PDF_URL?.trim() || DEFAULT_WHITEPAPER

/**
 * Absolute whitepaper URL for machine-readable surfaces (/stats.json, /llms*.txt).
 * Resolves the (possibly relative) WHITEPAPER_PDF_URL against the canonical origin,
 * so every surface agrees even when the env override points at an external host.
 */
export function resolveWhitepaperUrl(): string {
  return WHITEPAPER_PDF_URL.startsWith("http") ? WHITEPAPER_PDF_URL : `${SITE_URL}${WHITEPAPER_PDF_URL}`
}
